// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-container .code-btn,.form-container .el-input{border:1px solid #000;border-radius:10px;overflow:hidden}.form-container input{border:none;overflow:hidden}.form-container .el-input:focus,.form-container .el-input:hover{border:1px solid #000}.code-input{width:80%;border-radius:10px 0 0 10px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
